import { Classroom } from '@/api/classroom'

const state = () => ({
    moduls: [],
    modul: null,
    LoadingModul: false,
    isSuccessModul: true,
    savedIdClassroomModule: 0,
    messageModul: '',
})

const getters = {
    modulList: state => state.moduls,
    modul: state => state.modul,
    isLoadingModul: state => state.isLoadingModul,
    isSuccessModul: state => state.isSuccessModul,
    messageModul: state => state.messageModul,
    savedIdClassroomModule: state => state.savedIdClassroomModule,
}

const actions = {
    async fetchAllModuls({ commit }, id) {

        commit('setModulIsLoading', true)
        commit('setSavedIdClassroomModule', id)
        await Classroom.modulList(id)
            .then(response => {
                commit('setModuls', response.data.data)
                commit('setModulIsLoading', false)
            })
            .catch(error => {
                console.log(error)
                commit('setModulIsLoading', false)
            })
    },
    async fetchDetailModul({ commit }, id) {
        commit('setModulIsLoading', true)
        await Classroom.modulDetail(id)
            .then(response => {
                // console.log(response)
                commit('setModulDetail', response.data.data)
                commit('setModulIsLoading', false)
            })
            .catch(error => {
                console.log(error)
                commit('setModulIsLoading', false)
            })
    },
    async updateModul({ commit }, modul) {
        const id = modul.id
        const payload = modul.payload

        await Classroom.modulEdit(id, payload)
            .then(response => {
                if (response.data.success) {
                    commit('setSuccessModul', true)
                    commit('setMessageModul', 'Berhasil Mengubah Modul')
                } else {
                    commit('setSuccessModul', false)
                    commit('setMessageModul', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessModul', false)
                commit('setMessageModul', error.errors[0].message)
            })
    },
    async addModul({ commit }, payload) {
        await Classroom.modulAdd(payload)
            .then(res => {
                if (res.data.success) {
                    commit('setSuccessModul', true)
                    commit('setMessageModul', 'Berhasil Menambahkan Modul')
                } else {
                    commit('setSuccessModul', false)
                    commit('setMessageModul', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessModul', false)
                commit('setMessageModul', error.errors[0].message)
            })
    },
    async deleteModul({ commit }, id) {
        // console.log(id)
        await Classroom.modulDelete(id)
            .then(res => {

                if (res.data.success) {
                    commit('setSuccessModul', true)
                    commit('setMessageModul', 'Berhasil Menghapus Modul')
                } else {
                    commit('setSuccessModul', false)
                    commit('setMessageModul', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessModul', true)
                commit('setMessageModul', error.errors[0].message)
            })
    }
}

const mutations = {
    setModuls: (state, moduls) => {
        state.moduls = moduls
    },

    setModulDetail: (state, modul) => {
        state.modul = modul
    },

    setModulIsLoading: (state, isLoadingModul) => {
        state.isLoadingModul = isLoadingModul
    },

    setSuccessModul: (state, isSuccessModul) => {
        state.isSuccessModul = isSuccessModul
    },

    setMessageModul: (state, messageModul) => {
        state.messageModul = messageModul
    },
    setSavedIdClassroomModule: (state, savedIdClassroomModule) => {
        state.savedIdClassroomModule = savedIdClassroomModule
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}